export enum ConsentFormTypeEnum {
  TEXT = 'text',
  QUESTION = 'question',
  INPUT = 'input',
  SIGNATURE = 'signature',
  DATE = 'date',
  SIGNATURE_NAME_DATE = 'signatureWithNameDate',
}

export enum QuestionTypeEnum {
  NUMBER = 'number',
  STRING = 'string',
  SCALE = 'scale',
  TIME = 'time',
  OPTIONS = 'options',
  YES_NO = 'yes-no',
  NUMBER_RANGE = 'number-range',
  DATE_RANGE = 'date-range',
  TIME_RANGE = 'time-range',
  MULTIPLE_OPTIONS = 'multiple-option',
}
